<template lang="pug">
  .merklisten(v-if="merkliste")
    .wrap
      .metanav
        .left
          router-link(:to="{ name: 'home' }") {{ $t(`Zurück zur Fundus Übersicht`) }}
          router-link(to="/merklisten") {{ $t(`Merkliste verwalten`) }}
          strong {{ merkliste.name }}
        .right 
          strong(@click="showShare = true") {{ $t(`Teilen`) }}
          //-a(href="https://www.fundus.berlin/profil/") Benutzerdaten
          //-router-link.merklisten(to="/merklisten") {{ $t(`Ihre Merkliste`) }}
    .wrap.wrap--singlelist
      .uebersicht#merkliste
        .grid(v-if="merkliste.items.length > 0")
          merkliste-tile(:list="merkliste")
          fundus-tile(v-for="fundus in merkliste.items" :fundus="fundus.item" :listQuantity="parseInt(fundus.quantity)" :key="fundus.id").fundus
    transition(name="fade")
      modal(v-if="showShare" :modal="{ classes: 'share' }" v-on:modalClosed="closeModal")
        .box
          h1 {{ $t(`Merkliste teilen`) }}
          div(v-if="!shareSlug")
            p {{ $t(`Die Merkliste wird gespeichert und ein Link zum Teilen bereitgestellt. Mit diesem Link können Sie die Liste jeder Zeit wieder erstellen.`) }}
            button(type="submit" @click="getSharedLink" v-if="!loading") {{ $t(`Link anfordern`) }}
            div(v-else) {{ $t(`Versende`) }} ...
          div(v-else)
            p 
              router-link(:to="{ name: 'merkliste-vorschau', params: { slug: shareSlug } }") https://www.fundus.berlin/merkliste/vorschau/{{ shareSlug }}        
</template>

<script>
import NewListTile from '@/components/NewListTile.vue'
import MerklisteTile from '@/components/MerklisteTile.vue'
import FundusTile from '@/components/FundusTile.vue'
import Modal from '@/components/Modal.vue'
import { sendSharelist as apiSendSharelist } from '@/api'
export default {
  name: 'Merkliste',
  metaInfo () {
    if (typeof(this.merkliste) != "undefined") {
      return {
        title: `"${this.merkliste.name}" Merkliste`
      }
    }
  },
  data: () => ({
    showShare: false,
    loading: false,
    shareSlug: null
  }),
  components: {
    NewListTile,
    MerklisteTile,
    FundusTile,
    Modal
  },
  methods: {
    closeModal() {
      this.showShare = false
    },
    async getSharedLink () {
      this.loading = true
      try {
        const response = await apiSendSharelist({ liste: this.shareableData })
        this.loading = false
        this.shareSlug = response.data.slug
      } catch (error) {
        console.error(error)
        this.loading = false
      }
    }
  },
  computed: {
    merkliste: {
      get () {
        return this.$store.getters.wishlistById(this.$route.params.id)
      }
    },
    shareableData: {
      get () {
        const items = this.merkliste.items.map(item => {
          return {
            id: item.id,
            quantity: item.quantity
          }
        })
        return {
          name: this.merkliste.name,
          timestamp: this.merkliste.timestamp,
          items
        }
        /*
        // base64 encoded list data
        return btoa(unescape(encodeURIComponent(JSON.stringify({
          name: this.merkliste.name,
          timestamp: this.merkliste.timestamp,
          items
        }))))
        */
      }
    },
    decodedShareData: {
      get () {
        return JSON.parse(atob(this.shareableData))
      }
    }
  },
  created: function () {
    //this.$store.commit('CHANGE_CURRENT_WISHLIST', { wishlist: this.merkliste })
    this.$store.commit('CHANGE_CURRENT_LIST', this.merkliste.id)
    if (!this.merkliste) {
      this.$router.push('/')
    }
  },
  mounted () {
    window._paq.push(['setCustomUrl', window.location])
    window._paq.push(['setDocumentTitle', this.$metaInfo.title])
    window._paq.push(['trackPageView'])
  }
}
</script>

<style scoped lang="sass">
.wrap--singlelist
  position: relative
  min-height: 265px

.wrap--singlelist
  .liste
    position: relative
    width: 100%
    min-height: 204px
    margin: 0
    box-sizing: content-box

.modal--fundus.share
  .box
    background: #fff
    color: #000
    padding: 20px
    border-radius: 5px
    max-width: 500px
    box-sizing: border-box

#merkliste .meta
  top: 10px !important
.listview:first-child
  margin-left: 0 !important
  grid-column-start: 2
  @media only screen and (max-width: 400px)
    margin-top: 280px
    grid-column-start: inherit

.grid
  display: grid
  grid-template-columns: repeat(4, 1fr)
  grid-gap: 20px
  @media only screen and (max-width: 1000px)
    grid-template-columns: repeat(3, 1fr)
  @media only screen and (max-width: 769px)
    grid-template-columns: repeat(2, 1fr)
  @media only screen and (max-width: 400px)
    grid-template-columns: inherit
</style>
